export type Nullable<T> = T | null;

type Constructor<T> = { new (...args: any[]): T };
type PrimitiveOrConstructor<T> = Constructor<T> | 'string' | 'number' | 'boolean' | 'object';

export const typeCheck = <T>(ctx: any, ...className: Array<PrimitiveOrConstructor<T>>): ctx is T => {
  return className.some((c) => {
    if (typeof c === 'string') {
      return typeof ctx === c;
    }
    return ctx instanceof c;
  });
};

export const notEmpty = <TValue>(value: TValue | null | undefined): value is TValue => {
  return value !== null && value !== undefined;
};

export type ArgumentsOf<T> = T extends (...args: infer A) => any ? A : never;

export type FormikSetFieldError = (field: string, message: string | undefined) => void;

export type Recast<TObject, TType> = {
  [key in keyof TObject]: TObject[key] extends object ? Recast<TObject[key], TType> : TType;
};

export type NonNullableInside<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

export type NullableRecursive<T> = {
  [P in keyof T]: Nullable<T[P]>;
};
